import React from 'react';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import SkeletonBody from '@afosto/components-react/SkeletonBody';

const ParcelSkeleton = () => (
  <Card>
    <Box display="flex" px={2} py={1}>
      <Box style={{ backgroundColor: '#eee', height: 50, width: 50 }} mr={2} />
      <Box flex={1} pt={1}>
        <SkeletonBody lines={2} />
      </Box>
      <Box style={{ backgroundColor: '#eee', height: 25, width: 100 }} ml={3} mt={1.5} />
    </Box>
  </Card>
);

export default ParcelSkeleton;
